var _path, _path2;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgReplayButton(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 57,
    height: 57,
    viewBox: "0 0 57 57",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M57 28.5C57 36.1125 54.0355 43.2697 48.6526 48.6526C43.2697 54.0355 36.1125 57 28.5 57C20.8875 57 13.7303 54.0355 8.34743 48.6526C2.96455 43.2697 0 36.1125 0 28.5H4.45312C4.45312 41.7594 15.2406 52.5469 28.5 52.5469C41.7594 52.5469 52.5469 41.7594 52.5469 28.5C52.5469 15.2406 41.7594 4.45312 28.5 4.45312C19.8273 4.45312 11.9978 9.03367 7.72948 16.3652H14.4727V20.8184H0V6.3457H4.45312V13.1915C6.50965 9.96169 9.20414 7.16936 12.4109 4.97237C17.1598 1.7195 22.7231 0 28.5 0C36.1125 0 43.2697 2.96455 48.6526 8.34743C54.0355 13.7303 57 20.8875 57 28.5Z",
    fill: "white"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M21.2795 17.4438L40.4217 28.5L21.2795 39.5563V17.4438Z",
    fill: "white"
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgReplayButton);
export default __webpack_public_path__ + "static/media/replayButton.06af9ae93ba0716accae1f17c6b6a5cb.svg";
export { ForwardRef as ReactComponent };